import angular from 'angular';

angular
  .module('cxSettings')
  .controller('DeleteInvoiceTextConfirmDialogCtrl', [
    '$element',
    '$scope',
    'close',
    'relations',
    'schedules',
    deleteInvoiceTextConfirmDialogCtrl,
  ]);

function deleteInvoiceTextConfirmDialogCtrl($element, $scope, close, relations, schedules) {
  var vm = this;
  vm.schedules = schedules;
  vm.relations = relations;

  vm.close = function(result) {
    close(result, 500);
  };
}
